export var EFormLayoutModalActionType = /*#__PURE__*/function (EFormLayoutModalActionType) {
  EFormLayoutModalActionType["Opened"] = "formLayoutModal/opened";
  EFormLayoutModalActionType["Closed"] = "formLayoutModal/closed";
  return EFormLayoutModalActionType;
}({});